export var Screens;
(function (Screens) {
    Screens[Screens["Loading"] = 0] = "Loading";
    Screens[Screens["Settings"] = 1] = "Settings";
    Screens[Screens["Chart"] = 2] = "Chart";
    Screens[Screens["NotAuth"] = 3] = "NotAuth";
    Screens[Screens["NoLicence"] = 4] = "NoLicence";
})(Screens || (Screens = {}));
